export default __webpack_public_path__ + "static/media/icon-em-click-rate.59950c20.svg";